export default __webpack_public_path__ + "static/media/college2.4168f2a8.jpeg";